// Componente FAQ - Preguntas Frecuentes

const FAQ = () => {
  // Estilos inline para asegurar que las secciones ocupen todo el ancho disponible
  const sectionStyle = {
    width: '100%',
    margin: 0,
    padding: '60px 0',
    boxSizing: 'border-box',
  };

  const containerStyle = {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    boxSizing: 'border-box',
  };

  const faqs = [
    {
      question: "¿Cómo me puedo inscribir a las jornadas?",
      answer: "1. Regístrate como usuario.\n2. Completa los datos de tu futbolista (hijo/a).\n3. Adquiere jornadas sueltas o packs con descuento."
    },
    {
      question: "¿Tengo que apuntarme a todas las jornadas?",
      answer: "No, puedes elegir las jornadas que prefieras. La inscripción para las jornadas es individual y flexible."
    },
    {
      question: "¿Puede participar alguien que no ha estado nunca en ProKids?",
      answer: "¡Claro! Puedes unirte en cualquier momento, no importa si es la primera vez."
    },
    {
      question: "¿Cómo sabemos que juegan 40 minutos como mínimo?",
      answer: "En F8 formamos equipos con solo 3 cambios (uno por línea, excepto portero). Con este sistema rotativo garantizamos que todos juegan al menos 40 minutos.\n\nEn F11 son 4 cambios por equipo y el resultado es el mismo."
    },
    {
      question: "¿Tienen entrenador?",
      answer: "Sí, cada equipo tiene un entrenador que se encarga de:\n• Dirigir y arbitrar con equilibrio.\n• Realizar cambios rotativos.\n• Motivar y fomentar valores como respeto, humildad y esfuerzo.\n• Hacer correcciones y ajustes tácticos.\n• Determinar los puntos ProPoints según actitud, esfuerzo y rendimiento."
    },
    {
      question: "¿Cómo hacemos los partidos igualados?",
      answer: "Al inicio nos basamos en el formulario de inscripción, donde indicas el equipo y categoría en la que juega el niño/a. Más adelante, también ajustamos según las puntuaciones y rendimiento en partidos anteriores."
    },
    {
      question: "¿Cómo funciona el sistema ProPoints de evolución y reconocimiento individualizado?",
      answer: "Para más información sobre el sistema ProPoints, consulta nuestra sección dedicada en la aplicación."
    },
    {
      question: "¿Qué equipamiento necesita mi hijo para participar?",
      answer: "Cada jugador debe acudir con la equipación de Liga Prokids (la adquieres en tu primera inscripción), botas adecuadas, espinilleras y agua."
    },
    {
      question: "¿Qué ocurre si mi hijo no puede asistir a un partido en el que está inscrito?",
      answer: "En tu perfil de la App tienes la opción de posponer la jornada y no perderla siempre que lo hagas dentro de los plazos establecidos (antes del jueves a las 23:59)."
    },
    {
      question: "¿Cuándo y dónde son los partidos?",
      answer: "Los domingos por la mañana en Algorfa en 3 franjas horarias: 9:30-11:00 / 11:00-12:30 / 12:30-14:00\n\nRecibirás el aviso el viernes con la franja horaria que te corresponda."
    },
    {
      question: "¿Estos partidos son compatibles con los de mi equipo?",
      answer: "Por supuesto, es un complemento a la formación que reciben en sus clubes o escuelas. La diferencia es que aquí tienes garantizado jugar como mínimo 40 minutos por jornada."
    },
    {
      question: "¿Cuál es el precio de las jornadas?",
      answer: "14 euros la jornada suelta. Con los packs las jornadas pueden salirte a 13 euros (pack 5 jornadas) y 12 euros (pack 10 jornadas). Recuerda que puedes usar estas jornadas cuando quieras."
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero"
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          padding: '80px 0',
          overflow: 'hidden',
        }}
      >
        <div
          className="container"
          style={{
            ...containerStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontSize: '3rem',
              fontWeight: '700',
              marginBottom: '20px',
              color: '#061156',
              lineHeight: '1.2',
            }}
          >
            Preguntas Frecuentes - Liga ProKids
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
              marginBottom: '40px',
              color: '#061156',
              lineHeight: '1.6',
              maxWidth: '800px',
            }}
          >
            Encuentra respuestas a las preguntas más comunes sobre Liga ProKids.
          </p>
        </div>
      </section>

      {/* FAQ Content Section */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: 'white',
        }}
      >
        <div className="container" style={containerStyle}>
          <div
            style={{
              maxWidth: '1000px',
              margin: '0 auto',
            }}
          >
            {faqs.map((faq, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? '#F8F9FF' : 'white',
                  borderRadius: '15px',
                  padding: '30px',
                  marginBottom: '25px',
                  border: index % 2 === 0 ? '2px solid #E8ECFF' : '2px solid #E0E0E0',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                }}
              >
                <h3
                  style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#4352A9',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  <span>🔹</span>
                  {faq.question}
                </h3>
                <div
                  style={{
                    fontSize: '1.1rem',
                    color: '#061156',
                    fontWeight: '500',
                    lineHeight: '1.6',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          textAlign: 'center',
        }}
      >
        <div className="container" style={containerStyle}>
          <h2
            style={{
              fontSize: '2rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#061156',
            }}
          >
            ¿No encuentras tu respuesta?
          </h2>
          <p
            style={{
              fontSize: '1.1rem',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '30px',
            }}
          >
            Si tienes alguna pregunta que no aparece aquí, no dudes en contactarnos.
          </p>
          <a
            href="/contact"
            style={{
              display: 'inline-block',
              padding: '15px 40px',
              backgroundColor: '#4352A9',
              color: 'white',
              borderRadius: '30px',
              fontWeight: '600',
              fontSize: '1.1rem',
              textDecoration: 'none',
              border: '2px solid #4352A9',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(67, 82, 169, 0.3)',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#061156';
              e.target.style.borderColor = '#061156';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(6, 17, 86, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#4352A9';
              e.target.style.borderColor = '#4352A9';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(67, 82, 169, 0.3)';
            }}
          >
            Contactar
          </a>
        </div>
      </section>
    </>
  );
};

export default FAQ;
